module.exports = __webpack_public_path__ + "img/cl2_2.7a138ee3.png";